import React, { useState } from 'react';

const today = new Date().toISOString().split('T')[0];
const ALL_STATUSES = ['Saved', 'Applied', 'Screen', 'Interviewing', 'Offer', 'Withdrawn', 'Ghosted', 'Rejected', 'Accepted', 'Archived', 'Trashed'];

const BLANK = {
  company: '', role: '', location: '', salary: '',
  status: 'Saved', job_url: '', applied_date: '', deadline: '',
  notes: '', job_description: '', job_type: 'Full-time',
  remote_type: 'On-site', company_size: '',
};

function toDate(val) {
  if (!val) return '';
  try { return new Date(val).toISOString().split('T')[0]; } catch { return ''; }
}

const nullToStr = (obj) => Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v ?? '']));

export default function ApplicationModal({ application, onSave, onClose }) {
  const [tab, setTab] = useState('basic');
  const [form, setForm] = useState(application
    ? { ...BLANK, ...nullToStr(application), applied_date: toDate(application.applied_date), deadline: toDate(application.deadline) }
    : { ...BLANK }
  );
  const isSaved = form.status === 'Saved';

  const set = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const submit = e => { e.preventDefault(); onSave(form); };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{application ? 'Edit Application' : 'Add Application'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-tabs">
          {['basic', 'details', 'description'].map(t => (
            <button key={t} className={`modal-tab ${tab === t ? 'active' : ''}`} type="button" onClick={() => setTab(t)}>
              {t === 'basic' ? 'Basic Info' : t === 'details' ? 'Job Details' : 'Description'}
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="modal-form">
          {tab === 'basic' && (
            <>
              <div className="form-row">
                <div className="form-group">
                  <label>Company *</label>
                  <input name="company" value={form.company} onChange={set} required placeholder="e.g. Google" />
                </div>
                <div className="form-group">
                  <label>Role *</label>
                  <input name="role" value={form.role} onChange={set} required placeholder="e.g. SWE Intern" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Location</label>
                  <input name="location" value={form.location} onChange={set} placeholder="e.g. San Francisco, CA" />
                </div>
                <div className="form-group">
                  <label>Salary / Pay</label>
                  <input name="salary" value={form.salary} onChange={set} placeholder="e.g. $45/hr" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Status</label>
                  <select name="status" value={form.status} onChange={set}>
                    {ALL_STATUSES.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Job URL</label>
                  <input name="job_url" value={form.job_url} onChange={set} placeholder="https://..." />
                </div>
              </div>
              {!isSaved && (
                <div className="form-row">
                  <div className="form-group">
                    <label>Applied Date</label>
                    <input type="date" name="applied_date" value={form.applied_date} onChange={set} />
                  </div>
                  <div className="form-group">
                    <label>Deadline</label>
                    <input type="date" name="deadline" value={form.deadline} onChange={set} />
                  </div>
                </div>
              )}
              {isSaved && (
                <div className="form-row">
                  <div className="form-group">
                    <label>Deadline / Apply By</label>
                    <input type="date" name="deadline" value={form.deadline} onChange={set} />
                  </div>
                </div>
              )}
              <div className="form-group">
                <label>Notes</label>
                <textarea name="notes" value={form.notes} onChange={set} rows={3} placeholder="Recruiter name, referral, next steps..." />
              </div>
            </>
          )}

          {tab === 'details' && (
            <>
              <div className="form-row-3">
                <div className="form-group">
                  <label>Job Type</label>
                  <select name="job_type" value={form.job_type} onChange={set}>
                    {['Full-time','Part-time','Internship','Contract','Freelance'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Remote Type</label>
                  <select name="remote_type" value={form.remote_type} onChange={set}>
                    {['On-site','Hybrid','Remote'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Company Size</label>
                  <select name="company_size" value={form.company_size} onChange={set}>
                    <option value="">Unknown</option>
                    {['1–10','11–50','51–200','201–500','501–1000','1000–5000','5000+'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
              </div>
            </>
          )}

          {tab === 'description' && (
            <div className="form-group">
              <label>Job Description</label>
              <textarea
                name="job_description"
                value={form.job_description}
                onChange={set}
                rows={12}
                placeholder="Paste the full job description here. Used for AI keyword extraction."
              />
            </div>
          )}

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary">{application ? 'Save Changes' : 'Add Application'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
